import { colors, LayoutBand, Row, Skeleton, useContainerWidth } from '@fs/zion-ui'
import React from 'react'

export default function PersonPageTabsSkeleton(): JSX.Element {
  const atContainerWidth = useContainerWidth()
  const numButtonsToRemove = atContainerWidth({ sm: 0, xs: 1, default: 2 })
  const minWidth = atContainerWidth({ xl: 130, lg: 100, xs: 80, default: 60 })
  return (
    <LayoutBand maxWidth="lg" color={colors.gray00}>
      <Row guttersX="xs" alignX="center">
        {/* eslint-disable test-selectors/button -- NA */}
        <Skeleton.Button minWidth={minWidth} />
        <Skeleton.Button minWidth={minWidth} />
        <Skeleton.Button minWidth={minWidth} />
        {numButtonsToRemove < 1 && <Skeleton.Button minWidth={minWidth} />}
        {numButtonsToRemove < 2 && <Skeleton.Button minWidth={minWidth} />}
        {/* eslint-enable test-selectors/button -- NA */}
      </Row>
    </LayoutBand>
  )
}
